<template>
  <div>
    <v-layout class="p-4 pr-0 border-bottom-light-grey min-height-57px">
      <v-flex class="d-flex font-level-3-bold my-auto">
        <span class="detail-svg-icon mr-2">
          <!--begin::Svg Icon-->
          <span class="svg-icon svg-icon-lg mr-2 svg-v-list-icon">
            <inline-svg :src="$assetURL('media/custom-svg/attachment.svg')" />
          </span>
          <!--end::Svg Icon-->
        </span>
        <h1 class="form-title font-size-20 font-weight-700">
          <template v-if="typeText">
            {{ typeText }}
          </template>
          <template v-else> Files </template>
        </h1>
      </v-flex>
      <v-flex class="text-right">
        <v-tooltip bottom content-class="custom-bottom-tooltip" v-if="dbFiles && dbFiles.length > 0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn depressed class="custom-bold-button white--text ml-2" color="cyan"
              :loading="downloadAllLoading" :disabled="downloadAllLoading" v-bind="attrs" v-on="on"
              v-on:click="downloadAllZip()">
              <v-icon left>mdi-zip-box</v-icon> Download All
            </v-btn>
          </template>
          <span>Download Attachments (Zip)</span>
        </v-tooltip>


        <v-btn v-if="typeText != 'Visit Documents'" v-on:click="add_document_dialog = true" color="cyan text-white"
          class="ml-2" depressed tile><v-icon small left>mdi-playlist-plus</v-icon>Attach File
        </v-btn>
      </v-flex>
    </v-layout>
    <div class="overflow-y">
      <v-row>
        <template v-if="dbFiles.length">
          <v-col md="12" v-for="(row, index) in dbFiles" :key="index" class="border-bottom d-flex align-center py-1"
            :class="{
              'custom-border-top': index == 0,
              'orange_lighten-5': index % 2 == 0,
            }">
            <div class="px-4" style="width: 60px">
              <template v-if="row.extension && isImage(row.extension)">
                <ImageTemplate :src="row.file.url" style="max-width: 50px; width: 50px"></ImageTemplate>
              </template>
              <template v-else>
                <inline-svg style="max-width: 50px; width: 50px" :src="$assetURL(`media/mime/${row.extension}.svg`)" />
              </template>
            </div>
            <div style="width: 30%" class="px-4 text-truncate">
              <b class="blue--text text--darken-4 cursor-pointer" v-on:click="doAction(row, 'download')">{{ row.name
              }}</b>
              <b v-if="row.type_in_module" class="ml-3 red--text">({{ row.type_in_module }} - {{ row.module_type_parent
              }} )</b>
              <div>
                <b>Size:</b>{{ Number(Number(row.size) / 1024).toFixed(2) }}KB
              </div>
              <div v-if="row.type == 5001 && row.service_barcode">
                <template v-if="row.trip">
                  <v-chip color="red" class="font-weight-bold" outlined label small>{{ getBarcodeBytrip(row) }}</v-chip>
                </template>
                <template v-else>
                  <v-chip color="red" class="font-weight-bold" outlined label small>{{ getBarcode(row) }}</v-chip>
                </template>
              </div>
              <div v-if="
                (row &&
                  row.type &&
                  (row.type == 2 ||
                    row.type == 251 ||
                    row.type == 250 ||
                    row.type == 302 ||
                    row.type == 301)) ||
                row.type == 5005 ||
                row.type == 5006 ||
                row.type == 5007 ||
                row.type == 5008 ||
                row.type == 5015
              ">
                <v-chip :color="getTypeColor(row.type)" outlined text-color="" label small>
                  {{ getTypeName(row.type) }}</v-chip>
              </div>
            </div>
            <div style="width: 30%" class="px-4 d-flex flex-wrap">
              <div class="mr-10">
                <div>
                  <b class="d-inline-block" style="min-width: 64px">Start </b>:&nbsp;&nbsp;
                  <span v-if="row?.start_date">
                    {{ formatDate(row.start_date) }}
                  </span>
                  <em class="text-muted" v-else> no start </em>
                </div>
                <div>
                  <b class="d-inline-block" style="min-width: 64px">End </b>:&nbsp;&nbsp;
                  <span v-if="row?.end_date">
                    {{ formatDate(row.end_date) }}
                  </span>
                  <em class="text-muted" v-else> no end </em>
                </div>
                <div>
                  <b class="d-inline-block" style="min-width: 64px">Reminder </b>:&nbsp;&nbsp;
                  <span v-if="row?.reminder_date">
                    {{ formatDate(row.reminder_date) }}
                  </span>
                  <em class="text-muted" v-else> no reminder </em>
                </div>
              </div>
            </div>
            <div style="width: 20%" class="px-4">
              <template v-if="row.tags && row.tags?.length > 0">
                <v-chip small v-for="(tagRow, index) in row.tags" :key="index" class="mr-2 mb-1" text-color="white"
                  :color="tagRow?.color">{{ tagRow.tag }}</v-chip>
              </template>
              <em v-else class="text-muted"> no tags</em>
            </div>
            <div style="width: 15%" class="px-4 d-flex flex-wrap">
              <div class="mr-0">
                <div>
                  <v-chip v-if="row.user_display_name" class="mx-2 mb-1 custom-grey-border" color="cyan darken-1"
                    text-color="white" small label style="height: 20px !important">
                    <!-- <v-avatar left>
                      <v-icon>mdi-account-circle</v-icon>
                    </v-avatar> -->
                    <p class="m-0 custom-nowrap-ellipsis">
                      {{ row.user_display_name }}
                    </p>
                  </v-chip>
                  <em class="text-muted" v-else> no Created by </em>
                </div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip v-if="row.added_at" class="mx-2 my-0 custom-grey-border" v-bind="attrs" v-on="on"
                      style="height: 20px !important" color="cyan darken-1" text-color="white" small label>
                      <!-- <v-avatar left>
                        <v-icon>mdi-clock-outline</v-icon>
                      </v-avatar> -->
                      <p class="m-0 custom-nowrap-ellipsis">
                        {{ formatDate(row.added_at) }}
                      </p>
                    </v-chip>
                  </template>
                  <p class="m-0 custom-nowrap-ellipsis">
                    {{ formatDate(row.added_at) }}
                    {{ formatDateStartedNew(row.added_at) }}
                  </p>
                </v-tooltip>
              </div>
            </div>
            <div style="width: 10%" class="px-4 d-flex align-center">
              <v-spacer></v-spacer>
              <v-btn v-on:click="doAction(row, 'download')" :loading="Boolean(downloadingFiles[row.id])"
                :disabled="Boolean(downloadingFiles[row.id])" small icon depressed color="blue darken-4" class="mx-1">
                <v-icon medium>mdi-download</v-icon>
              </v-btn>
              <v-btn v-on:click="doAction(row, 'delete')" icon small depressed class="mx-1"
                color="red lighten-1"><v-icon medium>mdi-delete</v-icon></v-btn>
            </div>
          </v-col>
        </template>
        <template v-else>
          <v-col class="col-12 text-center border-top">
            <p class="m-1 row-not-found text-center font-weight-400 text-warning">
              <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
              Uhh... There are no file at the moment.
            </p>
            <hr />
          </v-col>
        </template>
      </v-row>

      <table width="100%" class="detail-table table-head-sticky" v-if="false">
        <thead>
          <tr style="border: 1px solid lightgray">
            <th class="p-2 light-blue-bg" width="200"></th>
            <th class="p-2 light-blue-bg" width="250">Name</th>
            <th v-if="extensive && typeText != 'Technicians'" class="p-2 light-blue-bg" width="200">
              Dates
            </th>
            <th v-if="extensive && typeText != 'Technicians'" class="p-2 light-blue-bg" width="300">
              Tags
            </th>
            <th v-if="extensive && typeText != 'Technicians'" class="p-2 light-blue-bg" width="300">
              Description
            </th>
          </tr>
        </thead>

        <tbody v-if="dbFiles.length">
          <tr v-for="(row, index) in dbFiles" :key="index" style="border: 1px solid lightgray">
            <td class="p-2 border-top-light-grey" width="50">
              <template v-if="row.extension && isImage(row.extension)">
                <ImageTemplate :src="row.file.url" style="max-width: 50px; width: 50px"></ImageTemplate>
              </template>
              <template v-else>
                <inline-svg style="max-width: 50px; width: 50px" :src="$assetURL(`media/mime/${row.extension}.svg`)" />
              </template>
            </td>
            <td class="p-2 border-top-light-grey" width="250">
              <p class="m-0 blue--text font-level-1 cursor-pointer bold-600" v-on:click="doAction(row, 'download')">
                {{ row.name }}
              </p>
              <div v-if="is_main" class="d-flex my-1">
                <p class="m-0 font-level-1 cursor-pointer bold-600">Type :</p>
                <v-badge class="mt-2 ml-2" :color="row.type_color ? row.type_color : '#58b5bd'"
                  :content="row.type.toUpperCase()"></v-badge>
              </div>

              <p class="m-0 text-muted font-small w-100">
                {{ formatDate(row.added_at) }}
              </p>
              <p class="m-0 text-muted font-small w-100">
                by {{ row.user_display_name }}
              </p>
            </td>

            <td v-if="extensive && typeText != 'Technicians'" class="p-2 border-top-light-grey">
              <template v-if="row.start_date && row.end_date">
                <div class="d-flex align-items-center">
                  <div :class="`${row.end_date && checkWExpDate(row.end_date)
                    ? 'expired'
                    : ''
                    }`">
                    <div class="d-flex align-items-center">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <label v-bind="attrs" v-on="on" class="font-size-14 mb-1 mr-7">
                            <v-badge color="cyan" content="S" class="badge-new"></v-badge>
                          </label>
                        </template>
                        <span> Start Date </span>
                      </v-tooltip>
                      <v-chip label class="mb-2">
                        {{ formatDate(row.start_date) }}
                      </v-chip>
                    </div>

                    <div class="d-flex align-items-center">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <label v-bind="attrs" v-on="on" class="font-size-14 mb-1 mr-7">
                            <v-badge color="red" content="E" class="badge-new"></v-badge>
                          </label>
                        </template>
                        <span> End Date </span>
                      </v-tooltip>
                      <v-chip label class="mb-2">
                        {{ formatDate(row.end_date) }}
                      </v-chip>
                    </div>
                    <div class="d-flex align-items-center">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <label v-bind="attrs" v-on="on" class="font-size-14 mb-1 mr-7">
                            <v-badge color="orange" content="R" class="badge-new"></v-badge>
                          </label>
                        </template>
                        <span> Reminder Date </span>
                      </v-tooltip>
                      <v-chip label class="mb-2">
                        {{ formatDate(row.reminder_date) }}
                      </v-chip>
                    </div>
                  </div>
                </div>
              </template>

              <template v-else>
                <em class="text--secondary">No Dates</em>
              </template>
            </td>

            <td v-if="extensive && typeText != 'Technicians'" class="p-2 border-top-light-grey">
              <template v-if="row.tags && row.tags.length > 0">
                <v-chip v-for="(tagRow, index) in row.tags" :key="`tag-${index}`" class="ma-2 tag" size="x-small"
                  color="#58b5bd" text-color="white">
                  {{ tagRow.text }}
                </v-chip>
              </template>
              <template v-else>
                <em class="text--secondary">No Tags Data</em>
              </template>
            </td>

            <td v-if="extensive && typeText != 'Technicians'" class="p-2 border-top-light-grey font-level-1"
              width="50%">
              <div class="d-flex justify-space-between">
                <template v-if="row && row.description && row.description != 'null'">
                  {{ row.description }}
                </template>
                <template v-else>
                  <em class="text--secondary"> No Description</em>
                </template>
                <div md1>{{ getFileSize(row.size) }} KB</div>
              </div>
            </td>

            <td class="p-2 border-top-light-grey font-level-1" width="150">
              <v-btn v-on:click="doAction(row, 'download')" :loading="Boolean(downloadingFiles[row.id])"
                :disabled="Boolean(downloadingFiles[row.id])" icon depressed color="blue darken-4" class="mr-2"><v-icon
                  medium>mdi-download</v-icon></v-btn>
              <v-btn v-on:click="doAction(row, 'delete')" icon depressed color="red lighten-1"><v-icon
                  medium>mdi-delete</v-icon></v-btn>
            </td>
          </tr>
        </tbody>
        <tfoot v-else>
          <tr>
            <td colspan="6">
              <p class="m-0 row-not-found text-center">
                <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                Uhh... There are no file at the moment.
              </p>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <DocumentwithName :document-dialog="add_document_dialog" v-on:close="add_document_dialog = false"
      v-on:success="getFiles()" :document-type="type" :document-id="typeId" :extensive="extensive"
      :parent-type="typeParent" :parent-type-id="typeParentId" :tag-type="tagType">
    </DocumentwithName>
    <Dialog :commonDialog="deleteDialog" :dialog-width="600">
      <template v-slot:title> Delete File</template>
      <template v-slot:body>
        <v-row class="delete-dialog">
          <v-col md="2" class="py-0 text-right my-auto">
            <span class="svg-icon svg-icon-lg delete-confirm-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/attention-circle.svg')" />
              <!--end::Svg Icon-->
            </span>
          </v-col>
          <v-col md="10" class="py-0 my-auto">
            <p class="btx-p m-0">
              Deleting File is irreversible, Are you sure about deleting it?
            </p>
          </v-col>
        </v-row>
      </template>
      <template v-slot:action>
        <v-btn class="white--text" :loading="deleteLoading" :disabled="deleteLoading" depressed color="red lighten-1"
          tile v-on:click="deleteFile()">
          Yes! Delete
        </v-btn>
        <v-btn depressed tile :disabled="deleteLoading" v-on:click="deleteDialog = false">
          No, Close
        </v-btn>
      </template>
    </Dialog>
  </div>
</template>
<script>
import { toNumber, round, find } from "lodash";
import ImageTemplate from "@/view/pages/Image";
//import Dialog from "@/view/components/Dialog";
import Dialog from "@/view/pages/partials/Dialog.vue";
//import TextAreaInput from "@/view/components/TextAreaInput";
import ApiService from "@/core/services/api.service";
import DocumentwithName from "@/view/pages/DocumentwithName";
//import { EventBus } from "@/core/event-bus/event.bus";
import moment from "moment-timezone";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
import CommonMixin from "@/core/plugins/common-mixin";
import fileDownload from "js-file-download";
export default {
  mixins: [CommonMixin],
  props: {
    isVisit: {
      type: Boolean,
      default: false,
    },
    tagType: {
      type: String,
      default: null,
    },
    typeText: {
      type: String,
      default: null,
    },
    type: {
      type: Number,
      default: null,
    },
    typeParent: {
      type: String,
      default: null,
    },
    typeUuid: {
      type: String,
      default: null,
    },
    typeId: {
      type: Number,
      default: null,
    },
    visitDetail: {
      type: Object,
      default: null,
    },
    typeParentId: {
      type: Number,
      default: null,
    },
    reload: {
      type: Boolean,
      default: false,
    },
    extensive: {
      type: Boolean,
      default: false,
    },
    is_main: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    reload(param) {
      if (param) {
        this.getFiles();
      }
    },
    typeId(param) {
      if (param) {
        this.getFiles();
      }
    },
  },
  computed: {
    isVisitModule() {
      return (
        this.isVisit ||
        this.type === 302 ||
        this.typeText === "visit" ||
        this.typeText === "Visit Documents"
      );
    },
    visitZipFileName() {
      if (this.visitDetail && this.visitDetail.barcode) {
        const trip = this.visitDetail.trip_count
          ? (String(this.visitDetail.trip_count).length === 1
            ? "0" + this.visitDetail.trip_count
            : this.visitDetail.trip_count)
          : "01";
        return `${this.visitDetail.barcode}-${trip}-Attachments.zip`;
      }
      return `VISIT-${this.typeId}-Attachments.zip`;
    },
  },
  data() {
    return {
      pageLoading: true,
      downloadAllLoading: false,
      downloadingFiles: {},
      deleteLoading: false,
      deleteDialog: false,
      attachDialog: false,
      attachLoading: false,
      uuid: null,
      description: null,
      files: [],
      dbFiles: [],
      add_document_dialog: false,
      extensionArray: ["jpg", "png", "gif", "jpeg", "webp", "tiff", "jfif"],
    };
  },
  methods: {
    formatDateStartedNew(param) {
      return moment(param).format("hh:mm A");
    },
    getReminderDateClass(endDate, reminderDate) {
      const end = new Date(endDate);
      const reminder = new Date(reminderDate);
      return reminder > end ? "text-danger" : "";
    },
    init() {
      this.deleteLoading = false;
      this.deleteDialog = false;
      this.attachDialog = false;
      this.attachLoading = false;
      this.uuid = null;
      this.description = null;
      this.files = [];
    },
    getTypeName(type) {
      if (type == 2) {
        return "Internal";
      } else if (type == 5006) {
        return "Rejected";
      } else if (type == 5005) {
        return "Accepted";
      } else if (type == 301) {
        return "Admin use only";
      } else if (type == 5007) {
        return "Approved";
      } else if (type == 5008) {
        return "UnApproved";
      } else if (type == 302) {
        return "Internal use only";
      } else if (type == 5015) {
        return "Terminated";
      }
    },
    getTypeColor(type) {
      if (type == 2) {
        return "#24326d";
      } else if (type == 5006) {
        return "red";
      } else if (type == 5005) {
        return "green";
      } else if (type == 5008) {
        return "red";
      } else if (type == 5007) {
        return "blue";
      } else if (type == 301) {
        return "red";
      } else if (type == 302) {
        return "green";
      } else if (type == 5015) {
        return "red";
      }
    },

    getBarcode(service) {
      let barcodeStr = this.visitDetail?.barcode.split("-");
      barcodeStr = barcodeStr[0];
      let perent = this.visitDetail?.barcode.replace(barcodeStr, "SRV");
      return perent + "-" + service.service_barcode;
    },
    getBarcodeBytrip(service) {
      let barcodeStr = this.visitDetail?.barcode.split("-");
      barcodeStr = barcodeStr[0];
      let perent = this.visitDetail?.barcode.replace(barcodeStr, "S");
      return perent + "-" + service.trip_code + "-" + service.service_barcode;
    },
    updateFiles(param) {
      if (param) {
        const max_size = toNumber(this.$uploadSizeLIMIT);
        const max_file = toNumber(this.$uploadLIMIT);
        for (let i = 0; i < param.length; i++) {
          const size = round(toNumber(param[i].size / 1024), 2);
          if (size <= max_size && this.files.length < max_file) {
            this.files.push(param[i]);
          }
        }
      }
    },
    getFileSize(size) {
      return round(toNumber(size) / 1024, 2);
    },
    removeFile(index) {
      this.files.splice(index, 1);
      this.$refs["upload-file"].value = null;
    },
    maxFileSize() {
      return round(toNumber(this.$uploadSizeLIMIT) / 1024, 2);
    },
    selectFile() {
      this.$refs["upload-file"].reset();
      this.$refs["upload-file"].$refs["input"].value = null;
      this.$nextTick(() => {
        this.$refs["upload-file"].$refs["input"].click();
      });
    },
    doAction(row, param) {
      switch (param) {
        case "download":
          this.downloadFileDirect(row);
          break;
        case "delete":
          this.id = row.id;
          this.deleteDialog = true;
          break;
      }
    },
    downloadFileDirect(row) {
      if (!row || !row.id) {
        if (row && row.file && row.file.url) {
          window.open(row.file.url, "_blank");
        }
        return;
      }
      let fileName =
        row.name || (row.file && row.file.name) || `attachment-${row.id}`;
      if (
        row.extension &&
        !fileName.toLowerCase().endsWith("." + row.extension.toLowerCase())
      ) {
        fileName += "." + row.extension;
      }
      this.$set(this.downloadingFiles, row.id, true);

      ApiService.setHeader();
      ApiService.download(`file-manager/download/${row.id}`)
        .then((response) => {
          fileDownload(response.data, fileName);
        })
        .catch((error) => {
          if (row.file && row.file.url) {
            fetch(row.file.url)
              .then((res) => {
                if (!res.ok) throw new Error("Network response was not ok");
                return res.blob();
              })
              .then((blob) => {
                fileDownload(blob, fileName);
              })
              .catch(() => {
                window.open(row.file.url, "_blank");
              });
          } else {
            this.$emit("error", error);
            this.logError(error);
          }
        })
        .finally(() => {
          this.$set(this.downloadingFiles, row.id, false);
        });
    },
    downloadAllZip() {
      if (this.downloadAllLoading) return;
      this.downloadAllLoading = true;

      const fileName = this.visitZipFileName;
      const visitId =
        this.visitDetail?.id ?? (this.type === 302 ? this.typeId : 0);

      ApiService.setHeader();
      ApiService.download(
        `documents/${this.type}/${this.typeId}/zip?visitId=${visitId}&file_name=${encodeURIComponent(
          fileName
        )}`
      )
        .then((response) => {
          fileDownload(response.data, fileName);
        })
        .catch((error) => {
          this.$emit("error", error);
          this.logError(error);
        })
        .finally(() => {
          this.downloadAllLoading = false;
        });
    },
    deleteFile() {
      if (!this.id) {
        return false;
      }
      this.deleteLoading = true;
      ApiService.setHeader();
      ApiService.delete(`delete-documents/${this.id}`)

        .then(() => {
          this.getFiles();
        })
        .catch((error) => {
          this.$emit("error", error);
          this.logError(error);
        })
        .finally(() => {
          this.deleteLoading = false;
        });
    },
    getFiles() {
      ApiService.setHeader();
      ApiService.get(
        `documents/${this.type}/${this.typeId}?visitId=${this.visitDetail?.id ?? 0
        }`
      )

        .then(({ data }) => {
          this.dbFiles = data.data;
          this.init();
        })
        .catch((error) => {
          this.$emit("error", error);
          this.logError(error);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },

    attachFile() {
      const params = new FormData();

      for (let i = 0; i < this.files.length; i++) {
        params.append(`file[${i}]`, this.files[i]);
      }

      params.append("description", this.description);

      this.attachLoading = true;

      ApiService.setHeader();
      ApiService.upload(`${this.type}/file`, params)
        .then(() => {
          this.getFiles();
          this.$refs["upload-file"].value = null;
        })
        .catch((error) => {
          this.$emit("error", error);
          this.logError(error);
        })
        .finally(() => {
          this.attachLoading = false;
        });
    },
    isImage(ext) {
      if (find(this.extensionArray, (row) => row == ext.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },
    checkWExpDate(date) {
      /* let currentData = MomentJS();
      let enddate = MomentJS(date, "DD/MM/YYYY");
      console.log(enddate.diff(currentData, "days"));
      if (enddate.diff(currentData, "days") > 0) {
        return false;
      }
      return true; */

      let currentData = moment();
      let enddate = moment(date, "YYYY-MM-DD");
      if (enddate.diff(currentData, "days") >= 0) {
        return false;
      }
      return true;
    },
  },
  components: {
    Dialog,
    //	TextAreaInput,
    ImageTemplate,
    DocumentwithName,
  },
  mounted() {
    console.log(this.type);
    if (this.typeId > 0) {
      this.getFiles();
    }

    // EventBus.$on("reload:asset", () => {
    // 	this.getFiles();
    // });
  },
};
</script>
<style scoped>
.custom-min-height-60vh {
  height: 77vh;
}

.v-window {
  overflow: auto !important;
}

.v-chip.v-size--default.tag {
  height: auto !important;
  padding: 1px 8px !important;
}
</style>
<style>
#attachment .overflow-y {
  max-height: none !important;
}

.text-danger {
  color: red;
}

.row-not-found-image {
  width: 30px !important;
}
</style>
